<app-header [forceLightBackground]="true"></app-header>
<div class="provider-activities">
  <div class="provider-activities--layout">
    <app-provider-sidebar class="provider-activities--sidebar"></app-provider-sidebar>
    <div class="provider-activities--content">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true" [hideUsecaseFilter]="true" [providerActivityFilter]="true"></app-activities>
    </div>
  </div>
</div>

